document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('[data-module="apps"] .yotpo-widget-instance')
  const status = {
    movedHeading: false,
    movedReviewer: false
  }
  if (!el) return
  const moveHeading = () => {
    if (status.movedHeading) return
    const headerEl = el.querySelector('.yotpo-head')
    const emptyEl = el.querySelector('.yotpo-empty-state')
    const headerContainerEl = el.querySelector('.yotpo-header-container')
    if (!headerEl) return
    if (emptyEl) {
      emptyEl.insertAdjacentElement('beforebegin', headerEl)
    } else if (headerContainerEl) {
      headerContainerEl.insertAdjacentElement('afterbegin', headerEl)
    }
    status.movedHeading = true
  }
  const moveReviewer = () => {
    if (status.movedReviewer) return
    const reviewEls = el.querySelectorAll('.yotpo-review')
    if (!reviewEls.length) return
    reviewEls.forEach(reviewEl => {
      const reviewerEl = reviewEl.querySelector('.yotpo-reviewer')
      const reviewDateEl = reviewEl.querySelector('.yotpo-review-date')
      const starEl = reviewEl.querySelector('.yotpo-star-rating.yotpo-review-star-rating')
      if (starEl && reviewerEl) {
        starEl.insertAdjacentElement('afterend', reviewerEl)
      }
      reviewDateEl && reviewDateEl.removeAttribute('aria-label')
    })
    status.movedReviewer = true
  }
  const observer = new MutationObserver(() => {
    const headerEl = el.querySelector('.yotpo-head')
    const emptyEl = el.querySelector('.yotpo-empty-state')
    const headerContainerEl = el.querySelector('.yotpo-header-container')
    const reviewEls = el.querySelectorAll('.yotpo-review')
    if (headerEl && (emptyEl || headerContainerEl)) {
      moveHeading()
    }
    if (reviewEls.length) {
      moveReviewer()
    }
  })
  const config = {
    attributes: false,
    childList: true,
    subtree: true
  }
  observer.observe(el, config)
})
